<template>
  <component
    :is="tagName"
    :class="disabled ? classNames.disabled : enabledClassNames"
    :disabled="disabled"
    :to="to"
    class="px-4 py-3 font-medium transition duration-150 border-2"
  >
    <slot></slot>
  </component>
</template>
<script>
import Vue from "vue";

const classNames = {
  primary:
    "text-white border-blue bg-blue hover:bg-blue-dark hover:border-blue-dark",
  secondary: "text-white border-gray-700 bg-gray-700",
  tertiary:
    "text-blue hover:text-blue-dark border-gray-300 border-solid hover:border-gray-300 hover:bg-gray-100",
  disabled: "bg-gray-300 text-gray-500"
};

export default Vue.extend({
  data() {
    return {
      classNames
    };
  },
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    tertiary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    enabledClassNames() {
      if (this.primary) {
        return this.classNames.primary;
      } else if (this.secondary) {
        return this.classNames.secondary;
      } else if (this.tertiary) {
        return this.classNames.tertiary;
      }

      return this.classNames.primary;
    },
    tagName() {
      if (!!this.to) {
        return "router-link";
      }
      return "button";
    }
  }
});
</script>
